/**
 * Key derivation for ui-config-driven permission data (tabs/buttons from
 * POST .../fetch-uiconfig { resourceName: "dashboard_info" }).
 *
 * A button/action key in that response is the snake_case form of its
 * ACTIONS_LIST label — one generic rule instead of a hand-maintained mapping
 * per page. We don't rename anything in ACTIONS_LIST/PrivateComponent for
 * this — callers keep passing the label unchanged; this conversion happens
 * only inside the ui-config engine when it looks the key up:
 *
 *   toActionKey("Edit Name")        === "edit_name"
 *   toActionKey("Reject Document")  === "reject_document"
 *   toActionKey("Cancel Application") === "cancel_application"
 */
export function toActionKey(label: string): string {
  return label.trim().toLowerCase().replace(/\s+/g, "_");
}

/**
 * Case/separator-insensitive form of a key. Used to compare an ACTIONS_LIST
 * label against a response key without both sides having to already agree
 * on exact formatting — "edit_name" and "Edit Name" (and any future key
 * style) all reduce to the same value, so lookups stay correct even if the
 * API's key convention shifts.
 */
export function canonicalizeKey(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "");
}
